import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";
import Typography from "material-ui/Typography";
import Checkbox from "material-ui/Checkbox";
import { sentStatusMenu, corporationSentStatusMenu, followCallOrderStatusMenu } from '../../constants/SidebarValues';

const sectionMenu = {
  section: {
    width: "100%",
    position: "relative",
  },

  collapsed: {
    maxHeight: "200px",
    overflowY: "hidden",
  },

  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderBottom: "1px solid #D8DBDF",
    marginBottom: '12px',
    paddingBottom: "5px",
    position: "relative",
    cursor: "pointer",
    "&:hover": {
      "& $arrow": {
        visibility: "visible",
        opacity: 1,
      },
    },
  },

  sectionBody: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "100%",
  },

  entry: {
    paddingTop: '8px',
    boxSizing: "border-box",
    position: "relative",
    display: "inline-flex",
    alignItems: "flex-start",
    transition:
      "transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  arrow: {
    transform: "translateX(-100%)",
    position: "absolute",
    left: 0,
    visibility: "hidden",
    opacity: 0,
    width: "unset",
    height: "unset",
    transition:
      "transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  menuItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  subMenuItem: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "30px",
    flexDirection: "row",
  },

  startAdornment: {
    width: "13px",
    height: "100%",
    borderLeft: "1px solid #D8DBDF",
    paddingRight: "4px",
  },

  rightTop: {
    height: "50%",
    width: "100%",
    borderBottom: "1px solid #D8DBDF",
  },

  rightBottom: {
    height: "50%",
    width: "100%",
  },

  text: {
    marginLeft: "5px",
    fontSize: "14px",
  },

  expandBtnContainer: {
    width: "100%",
    height: "60px",
    position: "absolute",
    bottom: 0,
  },

  gradient: {
    width: "100%",
    height: "37px",
    background: "linear-gradient(transparent 0%, white 80%)",
  },

  expandBtnOutter: {
    height: "23px",
    background: "#FFFFFF",
    padding: "0px 4px",
    boxSizing: "border-box",
  },

  button: {
    color: "#1A65FF",
    fontSize: "11px",
    minHeight: "unset",
    padding: "6px 8px",
  },

  group: {
    flexDirection: "column",
  },

  formControlLabel: {
    fontSize: "14px",
    color: "#181819",
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
  },

  filterLink: {
    fontSize: "11px",
    marginLeft: "25px",
    cursor: "pointer",
  },
};

class Submenu extends React.Component {
  state = {
    open: true,
    collapsed: true,
  };

  renderSubMenu = (parent) => {
    const { classes, selectSubmenu, set, disabled, user } = this.props;

    if (
      Array.isArray(parent.submenu) &&
      set.has(parent.value.toString()) &&
      parent.submenu.length > 0
    ) {
      return (
        <div
          className={classes.menuItem}
          style={{ padding: "0px 0px 10px 10px", display: (!user || user.parent_id || user.ownership_authority_flag) ? "" : "none" }}
        >
          {parent.submenu.map((item, i) => {
            return (
              <div
                className={classes.subMenuItem}
                key={parent.value + item.value + i}
              >
                <div className={classes.startAdornment}>
                  <div className={classes.rightTop}></div>
                  <div className={classes.rightBottom}></div>
                </div>
                <div className={classes.entry} style={{ cursor: "pointer" }}>
                  <Checkbox
                    color="primary"
                    checked={
                      set.has(parent.value) &&
                      set.get(parent.value).includes(item.value)
                    }
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                    value={item.value.toString()}
                    onChange={() =>
                      selectSubmenu(
                        parent.value.toString(),
                        item.value.toString()
                      )
                    }
                    disabled={disabled}
                  />
                  <div style={{ width: "200px", overflow: "auto" }}>
                    <Typography
                      variant="subheading"
                      style={{
                        marginLeft: "5px",
                        color: disabled ? "#B1B3B9" : "#181819",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() =>
                        selectSubmenu(
                          parent.value.toString(),
                          item.value.toString()
                        )
                      }
                    >
                      {item.name}
                    </Typography>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    return undefined;
  };

  render() {
    const {
      classes,
      title: _title,
      menuItems,
      deselectAll: _deselectAll,
      selectAll: _selectAll,
      select,
      set,
      disabled,
      selectSubmenu: _selectSubmenu,
      children: _children,
      isSubmenuSingleSelect: _isSubmenuSingleSelect,
      selectsubmenuSingleSelect: _selectsubmenuSingleSelect,
      toggleDateRangePickerDialog: _toggleDateRangePickerDialog,
      ...rest
    } = this.props;

    const displayMaxItemCount = 5;
    let collapsed = menuItems && menuItems.length > displayMaxItemCount && this.state.collapsed;

    return (
      <div className={classes.section} {...rest}>
        <div
          className={classNames(
            classes.sectionBody,
            collapsed ? classes.collapsed : ""
          )}
          style={{ display: this.state.open ? "flex" : "none" }}
        >
          {(() => {
            return menuItems.map((item, i) => (
              <div className={classes.menuItem} key={i}>
                <div className={classes.entry} style={{ cursor: "pointer" }}>
                  <Checkbox
                    color="primary"
                    checked={set.has((item.id || item.value).toString())}
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                    value={(item.id || item.value).toString()}
                    onChange={() =>
                      select((item.id || item.value).toString())
                    }
                    disabled={disabled}
                  />
                  <Typography
                    variant="subheading"
                    style={{ color: disabled ? "#B1B3B9" : "#181819" }}
                    className={classes.text}
                    onClick={() => select((item.id || item.value).toString())}
                  >
                    {item.name}
                  </Typography>
                  {!!item.isNew && (
                    <div className={classes.newLabel}>NEW</div>
                  )}
                </div>
                {item.submenu && (
                  this.renderSubMenu(item)
                )}
                {(sentStatusMenu.some(menu => menu.name === item.name)) && (
                  <div
                    className={classes.filterLink}
                    style={{ color: disabled ? '#B1B3B9' : '#1A65FF' }}
                    onClick={() => disabled ? false : this.props.toggleDateRangePickerDialog(item.name)}>注文日で絞り込む
                  </div>
                )}
                {(corporationSentStatusMenu.some(menu => menu.name === item.name)) && (
                  <div
                    className={classes.filterLink}
                    style={{ color: disabled ? '#B1B3B9' : '#1A65FF' }}
                    onClick={() => disabled ? false : this.props.toggleDateRangePickerDialog(item.name)}>注文日で絞り込む
                  </div>
                )}
                {(followCallOrderStatusMenu.some(menu => menu.name === item.name)) && (
                  <div
                    className={classes.filterLink}
                    style={{ color: disabled ? '#B1B3B9' : '#1A65FF' }}
                    onClick={() => disabled ? false : this.props.toggleDateRangePickerDialog(item.name)}>依頼日で絞り込む
                  </div>
                )}
              </div>
            ));
          })()}
        </div>
      </div>
    );
  }
}

Submenu.propTypes = {
  classes: PropTypes.object.isRequired,
  menuItems: PropTypes.array,
  select: PropTypes.func,
  selectSubmenu: PropTypes.func,
  selectsubmenuSingleSelect: PropTypes.func,
  set: PropTypes.object,
  disabled: PropTypes.bool,
  deselectAll: PropTypes.func,
  selectAll: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  isSubmenuSingleSelect: PropTypes.bool,
  user: PropTypes.object,
  toggleDateRangePickerDialog: PropTypes.func,
};

export default withStyles(sectionMenu)(Submenu);



// WEBPACK FOOTER //
// ./src/components/common/Submenu.jsx